<div class="modal-body">
  <div class="modal-header">
    <h3 class="modal-title">Document Details</h3>
    <button class="close-btn" (click)="onClose()">
      <img src="assets/icons/close-icon.svg" alt="Close" class="close-icon">
    </button>
  </div>

  <div class="document-layout">
    <div class="document-details">
      <div class="detail-row">
        <span class="detail-label">Document Name</span>
        <span class="detail-value">{{ document.name || '-' }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Collection Name</span>
        <span class="detail-value">{{ collectionName || '-' }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Category</span>
        <span class="detail-value">{{ document.category || '-' }}</span>
      </div>

      <div class="detail-row">
        <span class="detail-label">Size</span>
        <span class="detail-value">{{ document.size || '-' }}</span>
      </div>

      <div class="detail-row summary-row" *ngIf="getSummaryText()">
        <span class="detail-label">Summary</span>
        <span class="detail-value summary-text">{{ getSummaryText() }}</span>
      </div>

      <!-- <div class="sources-section" *ngIf="getDocumentSources().length > 0">
        <span class="detail-label">Sources</span>
        <ul class="sources-list">
          <li class="source-item" *ngFor="let source of getDocumentSources()">
            {{ source }}
          </li>
        </ul>
      </div> -->
    </div>
    <div class="key-topics-container">
      <div class="header">
        Key Topics
      </div>

      <div class="topics-list">
        <div class="topic-item" *ngFor="let topic of getKeywords()">
          {{ topic }}
        </div>
      </div>
    </div>
  </div>
</div>